import { Button } from "components/DesignSystem/Button/Button";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import ToolTip from "components/design/toolTip";
import { GroupByIcon } from "components/icons/GroupByIcon";
import {
  TXN_GROUP_BY,
  TxnGroupBy as TxnGroupByType,
} from "constants/bookkeeping";
import { useUpdateQuery } from "hooks/useQuery";
import { Chip } from "components/DesignSystem/Chips/Chips";
import { useWindowSize } from "hooks/useWindowSize";

type Props = {
  groupBy: TxnGroupByType | null;
};

export const TxnGroupBy = ({ groupBy }: Props) => {
  const { updateMultiple } = useUpdateQuery();
  const { isMobile } = useWindowSize();
  const isGroupedByVendor = groupBy === TXN_GROUP_BY.VENDOR;

  const enableGroupBy = () => {
    updateMultiple([
      { query: "group_by", value: TXN_GROUP_BY.VENDOR },
      { query: "page", value: "1" },
      { query: "page_size", value: "300" },
    ]);
  };

  const resetGroupBy = () => {
    updateMultiple([
      { query: "group_by", value: null },
      { query: "page", value: "1" },
      { query: "page_size", value: "20" },
    ]);
  };

  // On phones an active group-by is shown as a dot on the icon instead of a chip.
  const isActiveDotShown = Boolean(groupBy) && isMobile;
  const isChipShown = Boolean(groupBy) && !isMobile;

  let trigger = (
    <Button size="xsmall" customType="icon">
      <div className="t-relative t-flex t-items-center t-gap-1 t-text-text-30">
        <GroupByIcon />
        {isActiveDotShown && (
          <span className="t-absolute -t-right-1 -t-top-1 t-h-1.5 t-w-1.5 t-rounded-full t-bg-purple" />
        )}
      </div>
    </Button>
  );

  if (isChipShown && groupBy) {
    trigger = (
      <Chip
        isRemovable
        isActive
        size="xsmall"
        onRemove={resetGroupBy}
        filterType={groupBy}
        icon={
          <div className="t-flex t-items-center t-gap-1 t-text-text-30">
            <GroupByIcon />
          </div>
        }
      >
        {isGroupedByVendor && "Vendor"}
      </Chip>
    );
  }

  return (
    <Dropdown.Root modal={false}>
      <Dropdown.Trigger className="all:unset t-group t-self-center">
        <ToolTip text="Group" side="bottom" sideOffset={8}>
          <span>{trigger}</span>
        </ToolTip>
      </Dropdown.Trigger>
      <Dropdown.Portal>
        <Dropdown.Content align="start" className="!t-min-w-40" sideOffset={4}>
          <Dropdown.Label>Group by</Dropdown.Label>
          <Dropdown.Item
            className={isGroupedByVendor ? "!t-bg-purple-0" : ""}
            onSelect={enableGroupBy}
          >
            Vendor
          </Dropdown.Item>
          {groupBy && (
            <>
              <Dropdown.Separator />
              <Dropdown.Item onSelect={resetGroupBy}>
                <span className="t-text-purple">Reset</span>
              </Dropdown.Item>
            </>
          )}
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
};
